export const environment = {
    production: false,
    API_BASE_URL: 'https://dev-evaluation.sandbox.hs-nlp-g.com',
};
